import { render, staticRenderFns } from "./changePwd.vue?vue&type=template&id=58bc0476&scoped=true&"
import script from "./changePwd.vue?vue&type=script&lang=js&"
export * from "./changePwd.vue?vue&type=script&lang=js&"
import style0 from "./changePwd.vue?vue&type=style&index=0&id=58bc0476&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bc0476",
  null
  
)

export default component.exports